

module.exports = __webpack_require__.stylable.create(
    "Validity218158666",
    {"classes":{"root":"Validity218158666__root","duration":"Validity218158666__duration"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Validity218158666",
    null
);
